import { generalDomains } from './shared';
import { staging } from './data';
export const environment = {
    production: false,
    demo: false,
    isMobile: false,
    serviceWorkerEnabled: true,
    // APIEndPoint: 'https://athletex.2n.pl/api/athletex/v1/',
    APIEndPoint: 'https://server.staging.strya.co/api/athletex/v1/',
    defaultCredentials: null,
    googleMapsApiKey: 'AIzaSyAQycKPSsJhlYMJyloSlFekhu-xR1_ebi0',
    hotjarSiteId: null,
    generalDomains,
    data: staging,
    webAppUrl: 'https://staging.strya.co/',

};
